import { render, staticRenderFns } from "./CarteNonConformitePaginator.vue?vue&type=template&id=2c8835ce&scoped=true"
import script from "./CarteNonConformitePaginator.vue?vue&type=script&lang=js"
export * from "./CarteNonConformitePaginator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8835ce",
  null
  
)

export default component.exports